import { reviewAccess } from "@trip/domain/approval";

/**
 * Whether to show Approve on a revision: the same rule the server enforces (task owner or trip
 * admin for a task's project, never the uploader; reviewer or admin otherwise). The server still
 * decides; this only avoids offering a button that would be refused.
 */
export function canSeeApprove(x: {
  roles: string[];
  userId: string;
  taskOwnerId: string | null;
  revision: { authorId: string };
}): boolean {
  return (
    reviewAccess({
      roles: x.roles,
      userId: x.userId,
      taskOwnerId: x.taskOwnerId,
      revisionAuthorId: x.revision.authorId,
      decision: "APPROVE",
    }) === "ALLOWED"
  );
}

export const isAdmin = (roles: string[]) => roles.includes("ADMIN");
export const isEditor = (roles: string[]) => roles.includes("EDITOR");
